import createCachedSelector from 're-reselect';
import { createSelector } from 'reselect';

import { RateCorrectionsEditorContainerOwnProps } from '../../containers/RateCorrectionsEditorContainer/RateCorrectionsEditorContainer';
import { defaultCorrectionEditorState } from '../../reducers/rateCorrectionsEditor';
import { GdBidModifierType } from '../../typings/graphql-grid';
import { GroupId } from '../../typings/groups';
import {
    DeviceRateCorrectionType,
    RateCorrectionEditorState,
    RateCorrectionType
} from '../../typings/ratesCorrections';
import { RateCorrectionEditorsState, State } from '../../typings/state';

export const selectEnabledMobileDevices = (
    containerProps: RateCorrectionsEditorContainerOwnProps
): Array<DeviceRateCorrectionType> => {
    const device =
        containerProps.rateCorrectionsConstants &&
        containerProps.rateCorrectionsConstants[RateCorrectionType.device];

    if (device !== undefined) {
        return device.osTypes;
    }

    return [];
};

export const selectRateCorrectionsEditorByState = (
    state: RateCorrectionEditorsState,
    id: GroupId
): RateCorrectionEditorState => {
    return state[id] || defaultCorrectionEditorState;
};

export const selectEnabledDevices = createSelector(
    (containerProps: RateCorrectionsEditorContainerOwnProps) =>
        containerProps.enabledRateCorrections,
    selectEnabledMobileDevices,
    (
        enabledRateCorrections: Array<GdBidModifierType>,
        osTypes: Array<DeviceRateCorrectionType>
    ): Array<DeviceRateCorrectionType> => {
        const devicesArray: Array<DeviceRateCorrectionType> = [];

        if (
            enabledRateCorrections.includes(GdBidModifierType.MOBILE_MULTIPLIER)
        ) {
            devicesArray.push(DeviceRateCorrectionType.allMobile);
            devicesArray.push(...osTypes);
        }

        if (
            enabledRateCorrections.includes(
                GdBidModifierType.DESKTOP_MULTIPLIER
            )
        ) {
            devicesArray.push(DeviceRateCorrectionType.desktops);
        }

        return devicesArray;
    }
);

export const selectRateCorrectionsEditorValue = createCachedSelector(
    (state: State) => state.rateCorrectionsEditor,
    (state: State, editorId: string) => editorId,
    (
        editors: RateCorrectionEditorsState,
        editorId: string
    ): RateCorrectionEditorState => {
        return editors[editorId] || defaultCorrectionEditorState;
    }
)((state: State, editorId: string) => editorId);
